/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
import {
  ViewType,
  viewTypeToNumber,
  viewTypeFromJSON,
  viewTypeToJSON,
} from "./Accommodation/ViewType";
import {
  PoolType,
  poolTypeToNumber,
  poolTypeFromJSON,
  poolTypeToJSON,
} from "./Accommodation/PoolType";
import {
  Exterior,
  exteriorToNumber,
  exteriorFromJSON,
  exteriorToJSON,
} from "./Accommodation/Exterior";
import {
  MealType,
  mealTypeToNumber,
  mealTypeFromJSON,
  mealTypeToJSON,
} from "./MealType";
import {
  RoomClass,
  roomClassToNumber,
  roomClassFromJSON,
  roomClassToJSON,
} from "./RoomClass";

export enum DifferenceStatus {
  NoChange = "NoChange",
  Added = "Added",
  Removed = "Removed",
  HasChanged = "HasChanged",
}

export function differenceStatusFromJSON(object: any): DifferenceStatus {
  switch (object) {
    case 0:
    case "NoChange":
      return DifferenceStatus.NoChange;
    case 1:
    case "Added":
      return DifferenceStatus.Added;
    case 2:
    case "Removed":
      return DifferenceStatus.Removed;
    case 3:
    case "HasChanged":
      return DifferenceStatus.HasChanged;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " + object + " for enum DifferenceStatus"
      );
  }
}

export function differenceStatusToJSON(object: DifferenceStatus): string {
  switch (object) {
    case DifferenceStatus.NoChange:
      return "NoChange";
    case DifferenceStatus.Added:
      return "Added";
    case DifferenceStatus.Removed:
      return "Removed";
    case DifferenceStatus.HasChanged:
      return "HasChanged";
    default:
      return "UNKNOWN";
  }
}

export function differenceStatusToNumber(object: DifferenceStatus): number {
  switch (object) {
    case DifferenceStatus.NoChange:
      return 0;
    case DifferenceStatus.Added:
      return 1;
    case DifferenceStatus.Removed:
      return 2;
    case DifferenceStatus.HasChanged:
      return 3;
    default:
      return 0;
  }
}

export interface EnteringTheBoxDifference {
  accommodationDiff?: AccommodationDifferences;
  priceDiff?: PriceDifference;
  tourOperatorDiff?: TourOperatorDifference;
  remarksDiff?: TourOperatorRemarksDifferences;
  cancellationDiff?: CancellationDifference;
}

export interface AccommodationDifferences {
  transfer: AccommodationDifferences_Status;
  privateTransfer: AccommodationDifferences_Status;
  railAndFly: AccommodationDifferences_Status;
  viewTypeDiff?: ViewTypeDifference;
  poolTypeDiff?: PoolTypeDifference;
  mealTypeDiff?: MealTypeDifference;
  roomClassDiff?: RoomClassDifference;
  exteriorDiff?: ExteriorDifference;
}

export enum AccommodationDifferences_Status {
  NoChange = "NoChange",
  Removed = "Removed",
  Added = "Added",
}

export function accommodationDifferences_StatusFromJSON(
  object: any
): AccommodationDifferences_Status {
  switch (object) {
    case 0:
    case "NoChange":
      return AccommodationDifferences_Status.NoChange;
    case 1:
    case "Removed":
      return AccommodationDifferences_Status.Removed;
    case 2:
    case "Added":
      return AccommodationDifferences_Status.Added;
    default:
      throw new globalThis.Error(
        "Unrecognized enum value " +
          object +
          " for enum AccommodationDifferences_Status"
      );
  }
}

export function accommodationDifferences_StatusToJSON(
  object: AccommodationDifferences_Status
): string {
  switch (object) {
    case AccommodationDifferences_Status.NoChange:
      return "NoChange";
    case AccommodationDifferences_Status.Removed:
      return "Removed";
    case AccommodationDifferences_Status.Added:
      return "Added";
    default:
      return "UNKNOWN";
  }
}

export function accommodationDifferences_StatusToNumber(
  object: AccommodationDifferences_Status
): number {
  switch (object) {
    case AccommodationDifferences_Status.NoChange:
      return 0;
    case AccommodationDifferences_Status.Removed:
      return 1;
    case AccommodationDifferences_Status.Added:
      return 2;
    default:
      return 0;
  }
}

export interface PriceDifference {
  difference: number;
  relativeDifferencePercentage: number;
}

export interface TourOperatorDifference {
  oldTourOperator: string;
  newTourOperator: string;
}

export interface ViewTypeDifference {
  status: DifferenceStatus;
  old: ViewType;
  new: ViewType;
}

export interface PoolTypeDifference {
  status: DifferenceStatus;
  old: PoolType;
  new: PoolType;
}

export interface ExteriorDifference {
  status: DifferenceStatus;
  old: Exterior;
  new: Exterior;
}

export interface MealTypeDifference {
  status: DifferenceStatus;
  old: MealType;
  new: MealType;
}

export interface RoomClassDifference {
  status: DifferenceStatus;
  old: RoomClass;
  new: RoomClass;
}

export interface RemarkDifference {
  oldTitle: string;
  newTitle: string;
  oldDescription: string;
  newDescription: string;
  status: DifferenceStatus;
}

export interface TourOperatorRemarksDifferences {
  cancellation?: RemarkDifference;
  cancellationCost?: RemarkDifference;
  cancellationOptIn?: RemarkDifference;
  cancellationCostOptIn?: RemarkDifference;
  cancellationEconomic?: RemarkDifference;
  regular?: RemarkDifference;
  guarantee?: RemarkDifference;
  insurance?: RemarkDifference;
  rebookable?: RemarkDifference;
  lowDeposit?: RemarkDifference;
  special?: RemarkDifference;
}

export interface CancellationDifference {
  oldDaysAfterBooking: number;
  newDaysAfterBooking: number;
  oldValidUntil: string;
  newValidUntil: string;
  status: DifferenceStatus;
}

function createBaseEnteringTheBoxDifference(): EnteringTheBoxDifference {
  return {
    accommodationDiff: undefined,
    priceDiff: undefined,
    tourOperatorDiff: undefined,
    remarksDiff: undefined,
    cancellationDiff: undefined,
  };
}

export const EnteringTheBoxDifference = {
  encode(
    message: EnteringTheBoxDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.accommodationDiff !== undefined) {
      AccommodationDifferences.encode(
        message.accommodationDiff,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.priceDiff !== undefined) {
      PriceDifference.encode(
        message.priceDiff,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.tourOperatorDiff !== undefined) {
      TourOperatorDifference.encode(
        message.tourOperatorDiff,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.remarksDiff !== undefined) {
      TourOperatorRemarksDifferences.encode(
        message.remarksDiff,
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.cancellationDiff !== undefined) {
      CancellationDifference.encode(
        message.cancellationDiff,
        writer.uint32(42).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): EnteringTheBoxDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnteringTheBoxDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.accommodationDiff = AccommodationDifferences.decode(
            reader,
            reader.uint32()
          );
          break;
        case 2:
          message.priceDiff = PriceDifference.decode(reader, reader.uint32());
          break;
        case 3:
          message.tourOperatorDiff = TourOperatorDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 4:
          message.remarksDiff = TourOperatorRemarksDifferences.decode(
            reader,
            reader.uint32()
          );
          break;
        case 5:
          message.cancellationDiff = CancellationDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): EnteringTheBoxDifference {
    return {
      accommodationDiff: isSet(object.accommodationDiff)
        ? AccommodationDifferences.fromJSON(object.accommodationDiff)
        : undefined,
      priceDiff: isSet(object.priceDiff)
        ? PriceDifference.fromJSON(object.priceDiff)
        : undefined,
      tourOperatorDiff: isSet(object.tourOperatorDiff)
        ? TourOperatorDifference.fromJSON(object.tourOperatorDiff)
        : undefined,
      remarksDiff: isSet(object.remarksDiff)
        ? TourOperatorRemarksDifferences.fromJSON(object.remarksDiff)
        : undefined,
      cancellationDiff: isSet(object.cancellationDiff)
        ? CancellationDifference.fromJSON(object.cancellationDiff)
        : undefined,
    };
  },

  toJSON(message: EnteringTheBoxDifference): unknown {
    const obj: any = {};
    message.accommodationDiff !== undefined &&
      (obj.accommodationDiff = message.accommodationDiff
        ? AccommodationDifferences.toJSON(message.accommodationDiff)
        : undefined);
    message.priceDiff !== undefined &&
      (obj.priceDiff = message.priceDiff
        ? PriceDifference.toJSON(message.priceDiff)
        : undefined);
    message.tourOperatorDiff !== undefined &&
      (obj.tourOperatorDiff = message.tourOperatorDiff
        ? TourOperatorDifference.toJSON(message.tourOperatorDiff)
        : undefined);
    message.remarksDiff !== undefined &&
      (obj.remarksDiff = message.remarksDiff
        ? TourOperatorRemarksDifferences.toJSON(message.remarksDiff)
        : undefined);
    message.cancellationDiff !== undefined &&
      (obj.cancellationDiff = message.cancellationDiff
        ? CancellationDifference.toJSON(message.cancellationDiff)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<EnteringTheBoxDifference>
  ): EnteringTheBoxDifference {
    const message = createBaseEnteringTheBoxDifference();
    message.accommodationDiff =
      object.accommodationDiff !== undefined &&
      object.accommodationDiff !== null
        ? AccommodationDifferences.fromPartial(object.accommodationDiff)
        : undefined;
    message.priceDiff =
      object.priceDiff !== undefined && object.priceDiff !== null
        ? PriceDifference.fromPartial(object.priceDiff)
        : undefined;
    message.tourOperatorDiff =
      object.tourOperatorDiff !== undefined && object.tourOperatorDiff !== null
        ? TourOperatorDifference.fromPartial(object.tourOperatorDiff)
        : undefined;
    message.remarksDiff =
      object.remarksDiff !== undefined && object.remarksDiff !== null
        ? TourOperatorRemarksDifferences.fromPartial(object.remarksDiff)
        : undefined;
    message.cancellationDiff =
      object.cancellationDiff !== undefined && object.cancellationDiff !== null
        ? CancellationDifference.fromPartial(object.cancellationDiff)
        : undefined;
    return message;
  },
};

function createBaseAccommodationDifferences(): AccommodationDifferences {
  return {
    transfer: AccommodationDifferences_Status.NoChange,
    privateTransfer: AccommodationDifferences_Status.NoChange,
    railAndFly: AccommodationDifferences_Status.NoChange,
    viewTypeDiff: undefined,
    poolTypeDiff: undefined,
    mealTypeDiff: undefined,
    roomClassDiff: undefined,
    exteriorDiff: undefined,
  };
}

export const AccommodationDifferences = {
  encode(
    message: AccommodationDifferences,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.transfer !== AccommodationDifferences_Status.NoChange) {
      writer
        .uint32(8)
        .int32(accommodationDifferences_StatusToNumber(message.transfer));
    }
    if (message.privateTransfer !== AccommodationDifferences_Status.NoChange) {
      writer
        .uint32(16)
        .int32(
          accommodationDifferences_StatusToNumber(message.privateTransfer)
        );
    }
    if (message.railAndFly !== AccommodationDifferences_Status.NoChange) {
      writer
        .uint32(24)
        .int32(accommodationDifferences_StatusToNumber(message.railAndFly));
    }
    if (message.viewTypeDiff !== undefined) {
      ViewTypeDifference.encode(
        message.viewTypeDiff,
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.poolTypeDiff !== undefined) {
      PoolTypeDifference.encode(
        message.poolTypeDiff,
        writer.uint32(42).fork()
      ).ldelim();
    }
    if (message.mealTypeDiff !== undefined) {
      MealTypeDifference.encode(
        message.mealTypeDiff,
        writer.uint32(50).fork()
      ).ldelim();
    }
    if (message.roomClassDiff !== undefined) {
      RoomClassDifference.encode(
        message.roomClassDiff,
        writer.uint32(58).fork()
      ).ldelim();
    }
    if (message.exteriorDiff !== undefined) {
      ExteriorDifference.encode(
        message.exteriorDiff,
        writer.uint32(66).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): AccommodationDifferences {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAccommodationDifferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.transfer = accommodationDifferences_StatusFromJSON(
            reader.int32()
          );
          break;
        case 2:
          message.privateTransfer = accommodationDifferences_StatusFromJSON(
            reader.int32()
          );
          break;
        case 3:
          message.railAndFly = accommodationDifferences_StatusFromJSON(
            reader.int32()
          );
          break;
        case 4:
          message.viewTypeDiff = ViewTypeDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 5:
          message.poolTypeDiff = PoolTypeDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 6:
          message.mealTypeDiff = MealTypeDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 7:
          message.roomClassDiff = RoomClassDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 8:
          message.exteriorDiff = ExteriorDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): AccommodationDifferences {
    return {
      transfer: isSet(object.transfer)
        ? accommodationDifferences_StatusFromJSON(object.transfer)
        : AccommodationDifferences_Status.NoChange,
      privateTransfer: isSet(object.privateTransfer)
        ? accommodationDifferences_StatusFromJSON(object.privateTransfer)
        : AccommodationDifferences_Status.NoChange,
      railAndFly: isSet(object.railAndFly)
        ? accommodationDifferences_StatusFromJSON(object.railAndFly)
        : AccommodationDifferences_Status.NoChange,
      viewTypeDiff: isSet(object.viewTypeDiff)
        ? ViewTypeDifference.fromJSON(object.viewTypeDiff)
        : undefined,
      poolTypeDiff: isSet(object.poolTypeDiff)
        ? PoolTypeDifference.fromJSON(object.poolTypeDiff)
        : undefined,
      mealTypeDiff: isSet(object.mealTypeDiff)
        ? MealTypeDifference.fromJSON(object.mealTypeDiff)
        : undefined,
      roomClassDiff: isSet(object.roomClassDiff)
        ? RoomClassDifference.fromJSON(object.roomClassDiff)
        : undefined,
      exteriorDiff: isSet(object.exteriorDiff)
        ? ExteriorDifference.fromJSON(object.exteriorDiff)
        : undefined,
    };
  },

  toJSON(message: AccommodationDifferences): unknown {
    const obj: any = {};
    message.transfer !== undefined &&
      (obj.transfer = accommodationDifferences_StatusToJSON(message.transfer));
    message.privateTransfer !== undefined &&
      (obj.privateTransfer = accommodationDifferences_StatusToJSON(
        message.privateTransfer
      ));
    message.railAndFly !== undefined &&
      (obj.railAndFly = accommodationDifferences_StatusToJSON(
        message.railAndFly
      ));
    message.viewTypeDiff !== undefined &&
      (obj.viewTypeDiff = message.viewTypeDiff
        ? ViewTypeDifference.toJSON(message.viewTypeDiff)
        : undefined);
    message.poolTypeDiff !== undefined &&
      (obj.poolTypeDiff = message.poolTypeDiff
        ? PoolTypeDifference.toJSON(message.poolTypeDiff)
        : undefined);
    message.mealTypeDiff !== undefined &&
      (obj.mealTypeDiff = message.mealTypeDiff
        ? MealTypeDifference.toJSON(message.mealTypeDiff)
        : undefined);
    message.roomClassDiff !== undefined &&
      (obj.roomClassDiff = message.roomClassDiff
        ? RoomClassDifference.toJSON(message.roomClassDiff)
        : undefined);
    message.exteriorDiff !== undefined &&
      (obj.exteriorDiff = message.exteriorDiff
        ? ExteriorDifference.toJSON(message.exteriorDiff)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<AccommodationDifferences>
  ): AccommodationDifferences {
    const message = createBaseAccommodationDifferences();
    message.transfer =
      object.transfer ?? AccommodationDifferences_Status.NoChange;
    message.privateTransfer =
      object.privateTransfer ?? AccommodationDifferences_Status.NoChange;
    message.railAndFly =
      object.railAndFly ?? AccommodationDifferences_Status.NoChange;
    message.viewTypeDiff =
      object.viewTypeDiff !== undefined && object.viewTypeDiff !== null
        ? ViewTypeDifference.fromPartial(object.viewTypeDiff)
        : undefined;
    message.poolTypeDiff =
      object.poolTypeDiff !== undefined && object.poolTypeDiff !== null
        ? PoolTypeDifference.fromPartial(object.poolTypeDiff)
        : undefined;
    message.mealTypeDiff =
      object.mealTypeDiff !== undefined && object.mealTypeDiff !== null
        ? MealTypeDifference.fromPartial(object.mealTypeDiff)
        : undefined;
    message.roomClassDiff =
      object.roomClassDiff !== undefined && object.roomClassDiff !== null
        ? RoomClassDifference.fromPartial(object.roomClassDiff)
        : undefined;
    message.exteriorDiff =
      object.exteriorDiff !== undefined && object.exteriorDiff !== null
        ? ExteriorDifference.fromPartial(object.exteriorDiff)
        : undefined;
    return message;
  },
};

function createBasePriceDifference(): PriceDifference {
  return { difference: 0, relativeDifferencePercentage: 0 };
}

export const PriceDifference = {
  encode(
    message: PriceDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.difference !== 0) {
      writer.uint32(13).float(message.difference);
    }
    if (message.relativeDifferencePercentage !== 0) {
      writer.uint32(21).float(message.relativeDifferencePercentage);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PriceDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePriceDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.difference = reader.float();
          break;
        case 2:
          message.relativeDifferencePercentage = reader.float();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PriceDifference {
    return {
      difference: isSet(object.difference) ? Number(object.difference) : 0,
      relativeDifferencePercentage: isSet(object.relativeDifferencePercentage)
        ? Number(object.relativeDifferencePercentage)
        : 0,
    };
  },

  toJSON(message: PriceDifference): unknown {
    const obj: any = {};
    message.difference !== undefined && (obj.difference = message.difference);
    message.relativeDifferencePercentage !== undefined &&
      (obj.relativeDifferencePercentage = message.relativeDifferencePercentage);
    return obj;
  },

  fromPartial(object: DeepPartial<PriceDifference>): PriceDifference {
    const message = createBasePriceDifference();
    message.difference = object.difference ?? 0;
    message.relativeDifferencePercentage =
      object.relativeDifferencePercentage ?? 0;
    return message;
  },
};

function createBaseTourOperatorDifference(): TourOperatorDifference {
  return { oldTourOperator: "", newTourOperator: "" };
}

export const TourOperatorDifference = {
  encode(
    message: TourOperatorDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.oldTourOperator !== "") {
      writer.uint32(10).string(message.oldTourOperator);
    }
    if (message.newTourOperator !== "") {
      writer.uint32(18).string(message.newTourOperator);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.oldTourOperator = reader.string();
          break;
        case 2:
          message.newTourOperator = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorDifference {
    return {
      oldTourOperator: isSet(object.oldTourOperator)
        ? String(object.oldTourOperator)
        : "",
      newTourOperator: isSet(object.newTourOperator)
        ? String(object.newTourOperator)
        : "",
    };
  },

  toJSON(message: TourOperatorDifference): unknown {
    const obj: any = {};
    message.oldTourOperator !== undefined &&
      (obj.oldTourOperator = message.oldTourOperator);
    message.newTourOperator !== undefined &&
      (obj.newTourOperator = message.newTourOperator);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorDifference>
  ): TourOperatorDifference {
    const message = createBaseTourOperatorDifference();
    message.oldTourOperator = object.oldTourOperator ?? "";
    message.newTourOperator = object.newTourOperator ?? "";
    return message;
  },
};

function createBaseViewTypeDifference(): ViewTypeDifference {
  return {
    status: DifferenceStatus.NoChange,
    old: ViewType.UnknownView,
    new: ViewType.UnknownView,
  };
}

export const ViewTypeDifference = {
  encode(
    message: ViewTypeDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.status !== DifferenceStatus.NoChange) {
      writer.uint32(8).int32(differenceStatusToNumber(message.status));
    }
    if (message.old !== ViewType.UnknownView) {
      writer.uint32(16).int32(viewTypeToNumber(message.old));
    }
    if (message.new !== ViewType.UnknownView) {
      writer.uint32(24).int32(viewTypeToNumber(message.new));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ViewTypeDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseViewTypeDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = differenceStatusFromJSON(reader.int32());
          break;
        case 2:
          message.old = viewTypeFromJSON(reader.int32());
          break;
        case 3:
          message.new = viewTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ViewTypeDifference {
    return {
      status: isSet(object.status)
        ? differenceStatusFromJSON(object.status)
        : DifferenceStatus.NoChange,
      old: isSet(object.old)
        ? viewTypeFromJSON(object.old)
        : ViewType.UnknownView,
      new: isSet(object.new)
        ? viewTypeFromJSON(object.new)
        : ViewType.UnknownView,
    };
  },

  toJSON(message: ViewTypeDifference): unknown {
    const obj: any = {};
    message.status !== undefined &&
      (obj.status = differenceStatusToJSON(message.status));
    message.old !== undefined && (obj.old = viewTypeToJSON(message.old));
    message.new !== undefined && (obj.new = viewTypeToJSON(message.new));
    return obj;
  },

  fromPartial(object: DeepPartial<ViewTypeDifference>): ViewTypeDifference {
    const message = createBaseViewTypeDifference();
    message.status = object.status ?? DifferenceStatus.NoChange;
    message.old = object.old ?? ViewType.UnknownView;
    message.new = object.new ?? ViewType.UnknownView;
    return message;
  },
};

function createBasePoolTypeDifference(): PoolTypeDifference {
  return {
    status: DifferenceStatus.NoChange,
    old: PoolType.UnknownPoolType,
    new: PoolType.UnknownPoolType,
  };
}

export const PoolTypeDifference = {
  encode(
    message: PoolTypeDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.status !== DifferenceStatus.NoChange) {
      writer.uint32(8).int32(differenceStatusToNumber(message.status));
    }
    if (message.old !== PoolType.UnknownPoolType) {
      writer.uint32(16).int32(poolTypeToNumber(message.old));
    }
    if (message.new !== PoolType.UnknownPoolType) {
      writer.uint32(24).int32(poolTypeToNumber(message.new));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PoolTypeDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePoolTypeDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = differenceStatusFromJSON(reader.int32());
          break;
        case 2:
          message.old = poolTypeFromJSON(reader.int32());
          break;
        case 3:
          message.new = poolTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): PoolTypeDifference {
    return {
      status: isSet(object.status)
        ? differenceStatusFromJSON(object.status)
        : DifferenceStatus.NoChange,
      old: isSet(object.old)
        ? poolTypeFromJSON(object.old)
        : PoolType.UnknownPoolType,
      new: isSet(object.new)
        ? poolTypeFromJSON(object.new)
        : PoolType.UnknownPoolType,
    };
  },

  toJSON(message: PoolTypeDifference): unknown {
    const obj: any = {};
    message.status !== undefined &&
      (obj.status = differenceStatusToJSON(message.status));
    message.old !== undefined && (obj.old = poolTypeToJSON(message.old));
    message.new !== undefined && (obj.new = poolTypeToJSON(message.new));
    return obj;
  },

  fromPartial(object: DeepPartial<PoolTypeDifference>): PoolTypeDifference {
    const message = createBasePoolTypeDifference();
    message.status = object.status ?? DifferenceStatus.NoChange;
    message.old = object.old ?? PoolType.UnknownPoolType;
    message.new = object.new ?? PoolType.UnknownPoolType;
    return message;
  },
};

function createBaseExteriorDifference(): ExteriorDifference {
  return {
    status: DifferenceStatus.NoChange,
    old: Exterior.UnknownExterior,
    new: Exterior.UnknownExterior,
  };
}

export const ExteriorDifference = {
  encode(
    message: ExteriorDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.status !== DifferenceStatus.NoChange) {
      writer.uint32(8).int32(differenceStatusToNumber(message.status));
    }
    if (message.old !== Exterior.UnknownExterior) {
      writer.uint32(16).int32(exteriorToNumber(message.old));
    }
    if (message.new !== Exterior.UnknownExterior) {
      writer.uint32(24).int32(exteriorToNumber(message.new));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ExteriorDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseExteriorDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = differenceStatusFromJSON(reader.int32());
          break;
        case 2:
          message.old = exteriorFromJSON(reader.int32());
          break;
        case 3:
          message.new = exteriorFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): ExteriorDifference {
    return {
      status: isSet(object.status)
        ? differenceStatusFromJSON(object.status)
        : DifferenceStatus.NoChange,
      old: isSet(object.old)
        ? exteriorFromJSON(object.old)
        : Exterior.UnknownExterior,
      new: isSet(object.new)
        ? exteriorFromJSON(object.new)
        : Exterior.UnknownExterior,
    };
  },

  toJSON(message: ExteriorDifference): unknown {
    const obj: any = {};
    message.status !== undefined &&
      (obj.status = differenceStatusToJSON(message.status));
    message.old !== undefined && (obj.old = exteriorToJSON(message.old));
    message.new !== undefined && (obj.new = exteriorToJSON(message.new));
    return obj;
  },

  fromPartial(object: DeepPartial<ExteriorDifference>): ExteriorDifference {
    const message = createBaseExteriorDifference();
    message.status = object.status ?? DifferenceStatus.NoChange;
    message.old = object.old ?? Exterior.UnknownExterior;
    message.new = object.new ?? Exterior.UnknownExterior;
    return message;
  },
};

function createBaseMealTypeDifference(): MealTypeDifference {
  return {
    status: DifferenceStatus.NoChange,
    old: MealType.MealTypeUnknown,
    new: MealType.MealTypeUnknown,
  };
}

export const MealTypeDifference = {
  encode(
    message: MealTypeDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.status !== DifferenceStatus.NoChange) {
      writer.uint32(8).int32(differenceStatusToNumber(message.status));
    }
    if (message.old !== MealType.MealTypeUnknown) {
      writer.uint32(16).int32(mealTypeToNumber(message.old));
    }
    if (message.new !== MealType.MealTypeUnknown) {
      writer.uint32(24).int32(mealTypeToNumber(message.new));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MealTypeDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMealTypeDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = differenceStatusFromJSON(reader.int32());
          break;
        case 2:
          message.old = mealTypeFromJSON(reader.int32());
          break;
        case 3:
          message.new = mealTypeFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MealTypeDifference {
    return {
      status: isSet(object.status)
        ? differenceStatusFromJSON(object.status)
        : DifferenceStatus.NoChange,
      old: isSet(object.old)
        ? mealTypeFromJSON(object.old)
        : MealType.MealTypeUnknown,
      new: isSet(object.new)
        ? mealTypeFromJSON(object.new)
        : MealType.MealTypeUnknown,
    };
  },

  toJSON(message: MealTypeDifference): unknown {
    const obj: any = {};
    message.status !== undefined &&
      (obj.status = differenceStatusToJSON(message.status));
    message.old !== undefined && (obj.old = mealTypeToJSON(message.old));
    message.new !== undefined && (obj.new = mealTypeToJSON(message.new));
    return obj;
  },

  fromPartial(object: DeepPartial<MealTypeDifference>): MealTypeDifference {
    const message = createBaseMealTypeDifference();
    message.status = object.status ?? DifferenceStatus.NoChange;
    message.old = object.old ?? MealType.MealTypeUnknown;
    message.new = object.new ?? MealType.MealTypeUnknown;
    return message;
  },
};

function createBaseRoomClassDifference(): RoomClassDifference {
  return {
    status: DifferenceStatus.NoChange,
    old: RoomClass.Standard,
    new: RoomClass.Standard,
  };
}

export const RoomClassDifference = {
  encode(
    message: RoomClassDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.status !== DifferenceStatus.NoChange) {
      writer.uint32(8).int32(differenceStatusToNumber(message.status));
    }
    if (message.old !== RoomClass.Standard) {
      writer.uint32(16).int32(roomClassToNumber(message.old));
    }
    if (message.new !== RoomClass.Standard) {
      writer.uint32(24).int32(roomClassToNumber(message.new));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RoomClassDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRoomClassDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.status = differenceStatusFromJSON(reader.int32());
          break;
        case 2:
          message.old = roomClassFromJSON(reader.int32());
          break;
        case 3:
          message.new = roomClassFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RoomClassDifference {
    return {
      status: isSet(object.status)
        ? differenceStatusFromJSON(object.status)
        : DifferenceStatus.NoChange,
      old: isSet(object.old)
        ? roomClassFromJSON(object.old)
        : RoomClass.Standard,
      new: isSet(object.new)
        ? roomClassFromJSON(object.new)
        : RoomClass.Standard,
    };
  },

  toJSON(message: RoomClassDifference): unknown {
    const obj: any = {};
    message.status !== undefined &&
      (obj.status = differenceStatusToJSON(message.status));
    message.old !== undefined && (obj.old = roomClassToJSON(message.old));
    message.new !== undefined && (obj.new = roomClassToJSON(message.new));
    return obj;
  },

  fromPartial(object: DeepPartial<RoomClassDifference>): RoomClassDifference {
    const message = createBaseRoomClassDifference();
    message.status = object.status ?? DifferenceStatus.NoChange;
    message.old = object.old ?? RoomClass.Standard;
    message.new = object.new ?? RoomClass.Standard;
    return message;
  },
};

function createBaseRemarkDifference(): RemarkDifference {
  return {
    oldTitle: "",
    newTitle: "",
    oldDescription: "",
    newDescription: "",
    status: DifferenceStatus.NoChange,
  };
}

export const RemarkDifference = {
  encode(
    message: RemarkDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.oldTitle !== "") {
      writer.uint32(10).string(message.oldTitle);
    }
    if (message.newTitle !== "") {
      writer.uint32(18).string(message.newTitle);
    }
    if (message.oldDescription !== "") {
      writer.uint32(26).string(message.oldDescription);
    }
    if (message.newDescription !== "") {
      writer.uint32(34).string(message.newDescription);
    }
    if (message.status !== DifferenceStatus.NoChange) {
      writer.uint32(40).int32(differenceStatusToNumber(message.status));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RemarkDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemarkDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.oldTitle = reader.string();
          break;
        case 2:
          message.newTitle = reader.string();
          break;
        case 3:
          message.oldDescription = reader.string();
          break;
        case 4:
          message.newDescription = reader.string();
          break;
        case 5:
          message.status = differenceStatusFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RemarkDifference {
    return {
      oldTitle: isSet(object.oldTitle) ? String(object.oldTitle) : "",
      newTitle: isSet(object.newTitle) ? String(object.newTitle) : "",
      oldDescription: isSet(object.oldDescription)
        ? String(object.oldDescription)
        : "",
      newDescription: isSet(object.newDescription)
        ? String(object.newDescription)
        : "",
      status: isSet(object.status)
        ? differenceStatusFromJSON(object.status)
        : DifferenceStatus.NoChange,
    };
  },

  toJSON(message: RemarkDifference): unknown {
    const obj: any = {};
    message.oldTitle !== undefined && (obj.oldTitle = message.oldTitle);
    message.newTitle !== undefined && (obj.newTitle = message.newTitle);
    message.oldDescription !== undefined &&
      (obj.oldDescription = message.oldDescription);
    message.newDescription !== undefined &&
      (obj.newDescription = message.newDescription);
    message.status !== undefined &&
      (obj.status = differenceStatusToJSON(message.status));
    return obj;
  },

  fromPartial(object: DeepPartial<RemarkDifference>): RemarkDifference {
    const message = createBaseRemarkDifference();
    message.oldTitle = object.oldTitle ?? "";
    message.newTitle = object.newTitle ?? "";
    message.oldDescription = object.oldDescription ?? "";
    message.newDescription = object.newDescription ?? "";
    message.status = object.status ?? DifferenceStatus.NoChange;
    return message;
  },
};

function createBaseTourOperatorRemarksDifferences(): TourOperatorRemarksDifferences {
  return {
    cancellation: undefined,
    cancellationCost: undefined,
    cancellationOptIn: undefined,
    cancellationCostOptIn: undefined,
    cancellationEconomic: undefined,
    regular: undefined,
    guarantee: undefined,
    insurance: undefined,
    rebookable: undefined,
    lowDeposit: undefined,
    special: undefined,
  };
}

export const TourOperatorRemarksDifferences = {
  encode(
    message: TourOperatorRemarksDifferences,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.cancellation !== undefined) {
      RemarkDifference.encode(
        message.cancellation,
        writer.uint32(10).fork()
      ).ldelim();
    }
    if (message.cancellationCost !== undefined) {
      RemarkDifference.encode(
        message.cancellationCost,
        writer.uint32(18).fork()
      ).ldelim();
    }
    if (message.cancellationOptIn !== undefined) {
      RemarkDifference.encode(
        message.cancellationOptIn,
        writer.uint32(26).fork()
      ).ldelim();
    }
    if (message.cancellationCostOptIn !== undefined) {
      RemarkDifference.encode(
        message.cancellationCostOptIn,
        writer.uint32(34).fork()
      ).ldelim();
    }
    if (message.cancellationEconomic !== undefined) {
      RemarkDifference.encode(
        message.cancellationEconomic,
        writer.uint32(42).fork()
      ).ldelim();
    }
    if (message.regular !== undefined) {
      RemarkDifference.encode(
        message.regular,
        writer.uint32(50).fork()
      ).ldelim();
    }
    if (message.guarantee !== undefined) {
      RemarkDifference.encode(
        message.guarantee,
        writer.uint32(58).fork()
      ).ldelim();
    }
    if (message.insurance !== undefined) {
      RemarkDifference.encode(
        message.insurance,
        writer.uint32(66).fork()
      ).ldelim();
    }
    if (message.rebookable !== undefined) {
      RemarkDifference.encode(
        message.rebookable,
        writer.uint32(74).fork()
      ).ldelim();
    }
    if (message.lowDeposit !== undefined) {
      RemarkDifference.encode(
        message.lowDeposit,
        writer.uint32(82).fork()
      ).ldelim();
    }
    if (message.special !== undefined) {
      RemarkDifference.encode(
        message.special,
        writer.uint32(90).fork()
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): TourOperatorRemarksDifferences {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTourOperatorRemarksDifferences();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.cancellation = RemarkDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 2:
          message.cancellationCost = RemarkDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 3:
          message.cancellationOptIn = RemarkDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 4:
          message.cancellationCostOptIn = RemarkDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 5:
          message.cancellationEconomic = RemarkDifference.decode(
            reader,
            reader.uint32()
          );
          break;
        case 6:
          message.regular = RemarkDifference.decode(reader, reader.uint32());
          break;
        case 7:
          message.guarantee = RemarkDifference.decode(reader, reader.uint32());
          break;
        case 8:
          message.insurance = RemarkDifference.decode(reader, reader.uint32());
          break;
        case 9:
          message.rebookable = RemarkDifference.decode(reader, reader.uint32());
          break;
        case 10:
          message.lowDeposit = RemarkDifference.decode(reader, reader.uint32());
          break;
        case 11:
          message.special = RemarkDifference.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): TourOperatorRemarksDifferences {
    return {
      cancellation: isSet(object.cancellation)
        ? RemarkDifference.fromJSON(object.cancellation)
        : undefined,
      cancellationCost: isSet(object.cancellationCost)
        ? RemarkDifference.fromJSON(object.cancellationCost)
        : undefined,
      cancellationOptIn: isSet(object.cancellationOptIn)
        ? RemarkDifference.fromJSON(object.cancellationOptIn)
        : undefined,
      cancellationCostOptIn: isSet(object.cancellationCostOptIn)
        ? RemarkDifference.fromJSON(object.cancellationCostOptIn)
        : undefined,
      cancellationEconomic: isSet(object.cancellationEconomic)
        ? RemarkDifference.fromJSON(object.cancellationEconomic)
        : undefined,
      regular: isSet(object.regular)
        ? RemarkDifference.fromJSON(object.regular)
        : undefined,
      guarantee: isSet(object.guarantee)
        ? RemarkDifference.fromJSON(object.guarantee)
        : undefined,
      insurance: isSet(object.insurance)
        ? RemarkDifference.fromJSON(object.insurance)
        : undefined,
      rebookable: isSet(object.rebookable)
        ? RemarkDifference.fromJSON(object.rebookable)
        : undefined,
      lowDeposit: isSet(object.lowDeposit)
        ? RemarkDifference.fromJSON(object.lowDeposit)
        : undefined,
      special: isSet(object.special)
        ? RemarkDifference.fromJSON(object.special)
        : undefined,
    };
  },

  toJSON(message: TourOperatorRemarksDifferences): unknown {
    const obj: any = {};
    message.cancellation !== undefined &&
      (obj.cancellation = message.cancellation
        ? RemarkDifference.toJSON(message.cancellation)
        : undefined);
    message.cancellationCost !== undefined &&
      (obj.cancellationCost = message.cancellationCost
        ? RemarkDifference.toJSON(message.cancellationCost)
        : undefined);
    message.cancellationOptIn !== undefined &&
      (obj.cancellationOptIn = message.cancellationOptIn
        ? RemarkDifference.toJSON(message.cancellationOptIn)
        : undefined);
    message.cancellationCostOptIn !== undefined &&
      (obj.cancellationCostOptIn = message.cancellationCostOptIn
        ? RemarkDifference.toJSON(message.cancellationCostOptIn)
        : undefined);
    message.cancellationEconomic !== undefined &&
      (obj.cancellationEconomic = message.cancellationEconomic
        ? RemarkDifference.toJSON(message.cancellationEconomic)
        : undefined);
    message.regular !== undefined &&
      (obj.regular = message.regular
        ? RemarkDifference.toJSON(message.regular)
        : undefined);
    message.guarantee !== undefined &&
      (obj.guarantee = message.guarantee
        ? RemarkDifference.toJSON(message.guarantee)
        : undefined);
    message.insurance !== undefined &&
      (obj.insurance = message.insurance
        ? RemarkDifference.toJSON(message.insurance)
        : undefined);
    message.rebookable !== undefined &&
      (obj.rebookable = message.rebookable
        ? RemarkDifference.toJSON(message.rebookable)
        : undefined);
    message.lowDeposit !== undefined &&
      (obj.lowDeposit = message.lowDeposit
        ? RemarkDifference.toJSON(message.lowDeposit)
        : undefined);
    message.special !== undefined &&
      (obj.special = message.special
        ? RemarkDifference.toJSON(message.special)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<TourOperatorRemarksDifferences>
  ): TourOperatorRemarksDifferences {
    const message = createBaseTourOperatorRemarksDifferences();
    message.cancellation =
      object.cancellation !== undefined && object.cancellation !== null
        ? RemarkDifference.fromPartial(object.cancellation)
        : undefined;
    message.cancellationCost =
      object.cancellationCost !== undefined && object.cancellationCost !== null
        ? RemarkDifference.fromPartial(object.cancellationCost)
        : undefined;
    message.cancellationOptIn =
      object.cancellationOptIn !== undefined &&
      object.cancellationOptIn !== null
        ? RemarkDifference.fromPartial(object.cancellationOptIn)
        : undefined;
    message.cancellationCostOptIn =
      object.cancellationCostOptIn !== undefined &&
      object.cancellationCostOptIn !== null
        ? RemarkDifference.fromPartial(object.cancellationCostOptIn)
        : undefined;
    message.cancellationEconomic =
      object.cancellationEconomic !== undefined &&
      object.cancellationEconomic !== null
        ? RemarkDifference.fromPartial(object.cancellationEconomic)
        : undefined;
    message.regular =
      object.regular !== undefined && object.regular !== null
        ? RemarkDifference.fromPartial(object.regular)
        : undefined;
    message.guarantee =
      object.guarantee !== undefined && object.guarantee !== null
        ? RemarkDifference.fromPartial(object.guarantee)
        : undefined;
    message.insurance =
      object.insurance !== undefined && object.insurance !== null
        ? RemarkDifference.fromPartial(object.insurance)
        : undefined;
    message.rebookable =
      object.rebookable !== undefined && object.rebookable !== null
        ? RemarkDifference.fromPartial(object.rebookable)
        : undefined;
    message.lowDeposit =
      object.lowDeposit !== undefined && object.lowDeposit !== null
        ? RemarkDifference.fromPartial(object.lowDeposit)
        : undefined;
    message.special =
      object.special !== undefined && object.special !== null
        ? RemarkDifference.fromPartial(object.special)
        : undefined;
    return message;
  },
};

function createBaseCancellationDifference(): CancellationDifference {
  return {
    oldDaysAfterBooking: 0,
    newDaysAfterBooking: 0,
    oldValidUntil: "",
    newValidUntil: "",
    status: DifferenceStatus.NoChange,
  };
}

export const CancellationDifference = {
  encode(
    message: CancellationDifference,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.oldDaysAfterBooking !== 0) {
      writer.uint32(8).uint32(message.oldDaysAfterBooking);
    }
    if (message.newDaysAfterBooking !== 0) {
      writer.uint32(16).uint32(message.newDaysAfterBooking);
    }
    if (message.oldValidUntil !== "") {
      writer.uint32(26).string(message.oldValidUntil);
    }
    if (message.newValidUntil !== "") {
      writer.uint32(34).string(message.newValidUntil);
    }
    if (message.status !== DifferenceStatus.NoChange) {
      writer.uint32(40).int32(differenceStatusToNumber(message.status));
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): CancellationDifference {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCancellationDifference();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.oldDaysAfterBooking = reader.uint32();
          break;
        case 2:
          message.newDaysAfterBooking = reader.uint32();
          break;
        case 3:
          message.oldValidUntil = reader.string();
          break;
        case 4:
          message.newValidUntil = reader.string();
          break;
        case 5:
          message.status = differenceStatusFromJSON(reader.int32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): CancellationDifference {
    return {
      oldDaysAfterBooking: isSet(object.oldDaysAfterBooking)
        ? Number(object.oldDaysAfterBooking)
        : 0,
      newDaysAfterBooking: isSet(object.newDaysAfterBooking)
        ? Number(object.newDaysAfterBooking)
        : 0,
      oldValidUntil: isSet(object.oldValidUntil)
        ? String(object.oldValidUntil)
        : "",
      newValidUntil: isSet(object.newValidUntil)
        ? String(object.newValidUntil)
        : "",
      status: isSet(object.status)
        ? differenceStatusFromJSON(object.status)
        : DifferenceStatus.NoChange,
    };
  },

  toJSON(message: CancellationDifference): unknown {
    const obj: any = {};
    message.oldDaysAfterBooking !== undefined &&
      (obj.oldDaysAfterBooking = Math.round(message.oldDaysAfterBooking));
    message.newDaysAfterBooking !== undefined &&
      (obj.newDaysAfterBooking = Math.round(message.newDaysAfterBooking));
    message.oldValidUntil !== undefined &&
      (obj.oldValidUntil = message.oldValidUntil);
    message.newValidUntil !== undefined &&
      (obj.newValidUntil = message.newValidUntil);
    message.status !== undefined &&
      (obj.status = differenceStatusToJSON(message.status));
    return obj;
  },

  fromPartial(
    object: DeepPartial<CancellationDifference>
  ): CancellationDifference {
    const message = createBaseCancellationDifference();
    message.oldDaysAfterBooking = object.oldDaysAfterBooking ?? 0;
    message.newDaysAfterBooking = object.newDaysAfterBooking ?? 0;
    message.oldValidUntil = object.oldValidUntil ?? "";
    message.newValidUntil = object.newValidUntil ?? "";
    message.status = object.status ?? DifferenceStatus.NoChange;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  if (typeof self !== "undefined") return self;
  if (typeof window !== "undefined") return window;
  if (typeof global !== "undefined") return global;
  throw "Unable to locate global object";
})();

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
